"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAccess = void 0;
var lodash_1 = require("lodash");
var isSubset = function (source, subset) {
    return (0, lodash_1.isArray)(subset) ? subset.every(function (val) { return source.includes(val); }) : source.includes(subset);
};
var isAllowedUserRole = function (userRole, userRoles) {
    if (userRoles) {
        return (0, lodash_1.isArray)(userRoles) ? userRoles.includes(userRole) : userRoles === userRole;
    }
    return true;
};
var isAccessAllowedListSatisfied = function (userRole, allowList) {
    if (userRole && (allowList === null || allowList === void 0 ? void 0 : allowList.userRoles)) {
        return isAllowedUserRole(userRole, allowList === null || allowList === void 0 ? void 0 : allowList.userRoles);
    }
    return true;
};
var rowSatisfied = function (entitlementFlags, moduleFlags, launchDarklyFlags, userRole) {
    return function (row) {
        var _a, _b, _c;
        return (isSubset(entitlementFlags, (_a = row.entitlement) !== null && _a !== void 0 ? _a : []) &&
            isSubset(moduleFlags, (_b = row.module) !== null && _b !== void 0 ? _b : []) &&
            isSubset(launchDarklyFlags, (_c = row.launchDarkly) !== null && _c !== void 0 ? _c : []) &&
            isAccessAllowedListSatisfied(userRole, row.accessAllowList));
    };
};
/**
 * Checks whether a set of flags are sufficient to be granted a given rule
 *
 * @param ruleset
 * @param rule the rule from `ruleset` to be checked
 * @param entitlementFlags
 * @param moduleFlags
 * @param launchDarklyFlags
 * @param userRole
 * @returns true if the rule is granted, else false
 */
var hasAccess = function (ruleset, rule, entitlementFlags, moduleFlags, launchDarklyFlags, userRole) {
    var rows = ruleset[rule];
    var checker = rowSatisfied(entitlementFlags, moduleFlags, launchDarklyFlags, userRole);
    return (0, lodash_1.isArray)(rows) ? rows.some(checker) : checker(rows);
};
exports.hasAccess = hasAccess;
//# sourceMappingURL=helpers.js.map